const tasksEarnedSelector = (page: number) => (
    state: sage.state.IRedux
): sage.model.ITask[] | undefined => {
    return state.jobs.tasksEarned[page];
};

export default tasksEarnedSelector;
